export const devtoolsModule = [];
